import React, { Component, Suspense } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Loadable from "react-loadable";
import { ToastContainer } from "react-toastify";

import Loader from "../App/components/Loader";

import AuthRoute from "../hoc/AuthRoute";
import authRoutes from "../authRoutes";

import "./theme/index.scss";
import "react-toastify/dist/ReactToastify.css";
import "react-image-crop/dist/ReactCrop.css";
import "react-datepicker/dist/react-datepicker.css";
import "react-h5-audio-player/src/styles.scss";

const Layout = Loadable({
  loader: () => import("./layout"),
  loading: Loader,
});

class App extends Component {
  render() {
    const authPages = authRoutes.map((route, index) => {
      return route.component ? (
        <Route
          key={index}
          path={route.path}
          exact={route.exact}
          component={route.component}
        />
      ) : null;
    });

    return (
      <>
        <Suspense fallback={<Loader />}>
          <Switch>
            <Redirect exact from="/" to="/home" />
            {authPages}
            <AuthRoute path="/" component={Layout} />
          </Switch>
        </Suspense>
        <ToastContainer />
      </>
    );
  }
}

export default App;
